import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import Schemas from '../models';
import { actions } from '../../constants';
import { fetchListener } from './auth';
import { getUsersPagination } from '../selectors/users';

function* getUsers(data) {
  const onSuccess = function*(response) {
    yield put({ type: actions.USERS.LOAD_SUCCESS, payload: response });
  };

  const onError = function*(error) {
    yield put({ type: actions.USERS.LOAD_FAIL, payload: error });
  };

  let page = 1;
  if (!data.payload.refresh) {
    let pagination = yield select(getUsersPagination);

    if (pagination.current_page < pagination.total_pages) {
      page += 1;
    }
  }

  yield call(fetchListener, {
    url: 'api/users?page=' + page,
    method: 'GET',
    schema: Schemas.USER_ARRAY,
    onSuccess: onSuccess,
    onError: onError
  });
}

export default function* auth() {
  yield all([yield takeLatest(actions.USERS.LOAD, getUsers)]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/users.js